import React, {useContext, useEffect, useState} from 'react'
import headbandContext from 'contexts/headband'
import { QRCodeSVG } from 'qrcode.react'
import BigButton from 'components/buttons/bigButton'
import "./boiteIdee.scss"
import axios from 'axios'
import emailjs from 'emailjs-com';
export default function BoiteIdee(props) {
    const {setCounter, counterDefault} = props
    const {setHeadband} = useContext(headbandContext)
    const [opacity, setOpacity] = useState(1)
    const [sent, setSent] = useState(false)
    const [resultDisplay, setResultDisplay] = useState("")
    useEffect(() => {
        setHeadband({
            title : "Boîte à idées",
            icon : "picto_vote.svg",
            color : "bckOrange"
        })
    }, [])
    const [name, setName] = useState("")
    const [subject, setSubject] = useState("")
    const [message, setMessage] = useState("")
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_dp3mrf7', 'template_pga9etf', e.target, 'TsscPFMiOhJ9YTR3O')
            .then((result) => {
                console.log(result)
                setResultDisplay(result.text)
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
                setResultDisplay(error.text)
            }).then(() => {
                setCounter(5)
                setOpacity(0)
                setTimeout(() => setSent(true), 1000)
            })
    }
    return (
        <div id="boiteIdee" className='page flex center'>
            {!sent ? (
                <form className='flex column around' onSubmit={sendEmail} style={{opacity : opacity, transition : "0.5s", zIndex : "10"}}>
                    <section className="w100 flex between">
                        <label htmlFor="name">Votre nom et prénom</label>
                        <input type="text" name="name" value={name} onChange={(e) => {
                            setCounter(counterDefault)
                            setName(e.target.value)  
                        }}/>
                    </section>
                    <section className="w100 flex between">
                        <label htmlFor="subject">Votre sujet</label>
                        <input type="text" name='subject' value={subject} onChange={(e) => {
                            setCounter(counterDefault)
                            setSubject(e.target.value)
                        }}/>
                    </section>
                    <section className="w100 flex between column alignStart">
                        <label htmlFor="message">Votre message</label>
                        <textarea name="message" value={message} onChange={(e) => {
                            setCounter(counterDefault)
                            setMessage(e.target.value)
                        }}></textarea>
                    </section>
                    <section className="w100 flex center">
                        <input className='formBtn' type="submit" value="ENVOYER"/>
                    </section>
                    <section className='centerImg'>
                        <img src="/logo_chu_blanc.png" alt="" />
                    </section>
                </form>
            ) : (
                <h1>Votre message a bien été envoyé. Merci.</h1>
            )}
        </div>
    )
}
